import React from 'react';
import { Link } from 'react-router-dom';

const ImageGallery = ({ items }) => {
  if (!items || items.length === 0) {
    return <div className="w-16 h-16 bg-gray-100 rounded-xl flex items-center justify-center text-[10px] text-gray-400 border border-dashed border-gray-200">بدون تصویر</div>;
  }

  // نمایش حداکثر 4 تصویر در کارد اصلی
  const visibleItems = items.slice(0, 4);
  const remainingCount = items.length - 4;

  return (
    <div className="flex items-center gap-3 mt-4">
      {visibleItems.map((item, index) => (
        <Link
          key={index}
          to={`/shopping/product-detail/${item.product_slug}`}
          className="relative w-16 h-16 bg-gray-50 rounded-xl overflow-hidden border border-gray-100 hover:border-blue-300 transition-colors flex-shrink-0"
        >
          <img
            src={item.product_image || item} // سازگاری با هر دو مدل داده (آرایه رشته یا آرایه آبجکت)
            alt="product"
            className="w-full h-full object-cover"
          />
        </Link>
      ))}

      {remainingCount > 0 && (
        <div className="w-16 h-16 rounded-xl bg-gray-50 border border-gray-200 flex items-center justify-center text-gray-500 font-bold text-sm">
          +{remainingCount}
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
